import { gql } from 'urql';

const FetchCheckDepositHistory = gql`
  query FetchCheckDepositHistory($first: Int!, $after: String!) {
    rdcs(first: $first, after: $after) {
      edges {
        node {
          id
          submittedOn
          value {
            amount
            currency
          }
          rdcStatus {
            copy
            status
          }
          confirmationNumber
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export default FetchCheckDepositHistory;
